import { DeliveryAnalyticsTotalsSchema } from "@redotech/redo-model/analytics/analytics";
import z from "zod/v4";

export const getDeliveryAnalytics = {
  name: "getDeliveryAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    pageSize: z.number().positive().optional(),
    pageNumber: z.number().positive().optional(),
  }),
  output: DeliveryAnalyticsTotalsSchema,
};
